export const ORDER_SORT = {
  CUSTOM: "custom",
  NEWEST: "newest",
  OLDEST: "oldest",
} as const;

export type OrderSortType = typeof ORDER_SORT[keyof typeof ORDER_SORT];

export const ORDER_SORT_OPTIONS = [
  { value: ORDER_SORT.NEWEST, label: "Newest first" },
  { value: ORDER_SORT.OLDEST, label: "Oldest first" },
  { value: ORDER_SORT.CUSTOM, label: "Custom", disabled: true },
];
